var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00c853",
    d: "M4,23C4,11.954,12.954,3,24,3s20,8.954,20,20l-20,2L4,23z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00e676",
    d: "M44,23c0,11.046-8.954,20-20,20S4,34.046,4,23H44z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2eafd",
    d: "M39.29,42.34v3.16c0,0.19-0.1,0.35-0.25,0.43c-0.14,0.09-0.33,0.1-0.5,0l-2.72-1.59l-4.68-8.15 l-2-3.47l-3.75-6.52l2.93-2.93l3.99,6.94l2.07,3.6L39.29,42.34z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9addfb",
    d: "M31.231,28.335c-0.814,1.101-1.869,2.011-3.092,2.648l3.991,6.941 c1.185-0.648,2.272-1.446,3.265-2.346L31.231,28.335z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2eafd",
    d: "M39,23c0,4.24-1.77,8.08-4.62,10.81c-0.96,0.93-2.05,1.73-3.24,2.38C29.02,37.34,26.59,38,24,38 c-2.53,0-4.96-0.62-7.14-1.81l-4.68,8.15l-2.72,1.59c-0.17,0.1-0.36,0.09-0.5,0c-0.15-0.08-0.25-0.24-0.25-0.43v-3.16l10.97-19.07 l2.93,2.93l-3.75,6.53C20.43,33.56,22.18,34,24,34c1.86,0,3.61-0.46,5.14-1.28c1.21-0.63,2.28-1.49,3.17-2.51 C33.99,28.27,35,25.76,35,23H39z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474f",
    d: "M28.5,13H26v-3h-4v3h-2.5c-0.828,0-1.5,0.672-1.5,1.5V23l4.932,4.932c0.59,0.59,1.546,0.59,2.135,0 L30,23v-8.5C30,13.672,29.328,13,28.5,13z M24,22c-1.381,0-2.5-1.119-2.5-2.5c0-1.381,1.119-2.5,2.5-2.5s2.5,1.119,2.5,2.5 C26.5,20.881,25.381,22,24,22z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.8f9a456f43e29e050e89378de0105da9.svg";
export { ForwardRef as ReactComponent };